<template>
  <div style="min-height: 92vh">
    <h3>Existencias generales</h3>
    <v-row>
      <v-col>
        <v-autocomplete label="Departamentos" v-model="selectDep" item-text="Nombre" item-value="id"
          :items="departamentos"></v-autocomplete>
      </v-col>
      <v-col>
        <v-btn color="primary" @click="searchInv()"> Buscar </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="8" cols="12">
        <v-text-field v-model="filter" label="Filtrar"></v-text-field>
      </v-col>
      <v-col md="2" cols="12">
        <v-btn color="green" dark @click="exportarExcel">
          <v-icon>mdi-file-excel-box</v-icon>
          Exportar a Excel
        </v-btn>
      </v-col>
      <v-col md="2" cols="12">
        <v-btn color="red" dark @click="generatePdf">
          <v-icon>mdi-file-pdf-box</v-icon>
          Exportar a PDF
        </v-btn>
      </v-col>
    </v-row>

    <v-simple-table>
      <thead>
        <tr>
          <th width="10%">Producto</th>
          <th width="10%">Codigo</th>
          <th width="10%">Familia</th>
          <th width="10%">Categoria</th>
          <template v-for="(org, index) in Origenes">
            <th class="text-center" :key="index">
              {{ org.nombreOrigen }}
            </th>
          </template>
          <th>Existencia Total</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(prod, index) in productosShow">
          <tr :key="index">
            <td>{{ prod.Nombre }} - ({{ prod.UnidadMedida }})</td>
            <td>
              {{ prod.Codigo }}
            </td>
            <td>
              {{ prod.Familia }}
            </td>
            <td>
              {{ prod.categoria_name }}
            </td>
            <template v-for="(org, index) in Origenes">
              <td :key="index" class="text-center">
                <div v-if="prod.amcs">
                  <span class="text-caption" v-if="prod.amcs[org.Origen]">Min: {{ prod.amcs[org.Origen].emin }}
                    ||</span>
                  <span class="text-caption" v-if="prod.amcs[org.Origen]">
                    Ideal: {{ prod.amcs[org.Origen].eidl }}</span>
                </div>
                <div class="text-subtitle-2">
                  {{
                    prod.ExistenciaAlmacen[org.Origen]
                      ? $pgsHelper.formatNumber(
                        prod.ExistenciaAlmacen[org.Origen].Stock
                      ) +
                      " " +
                      prod.UnidadMedida
                      : "N/A"
                  }}
                </div>
                <div v-if="prod.amcs">
                  <div v-if="prod.amcs[org.Origen]">
                    <div class="text-caption" v-if="
                      prod.ExistenciaAlmacen[org.Origen] &&
                      prod.ExistenciaAlmacen[org.Origen].Stock <
                      prod.amcs[org.Origen].emin
                    ">
                      <p class="red--text mb-0">Baja existencia</p>
                    </div>
                    <div class="text-caption" v-if="
                      prod.ExistenciaAlmacen[org.Origen] &&
                      prod.ExistenciaAlmacen[org.Origen].Stock <
                      prod.amcs[org.Origen].eidl
                    ">
                      {{
                        $pgsHelper.formatNumber(
                          prod.amcs[org.Origen].eidl -
                          prod.ExistenciaAlmacen[org.Origen].Stock
                        )
                      }}
                      para ideal
                    </div>
                  </div>
                </div>
              </td>
            </template>
            <td class="text-center">
              <div v-if="getCalculatedGlobalLimits(prod)">
                <span class="text-caption">Min: {{ getCalculatedGlobalLimits(prod).Min }} ||</span>
                <span class="text-caption">
                  Ideal: {{ getCalculatedGlobalLimits(prod).Max }}</span>
              </div>
              <b>{{
                $pgsHelper.formatNumber(prod.ExitenciaTotal) +
                " " +
                prod.UnidadMedida
                }}</b>
              <div v-if="getCalculatedGlobalLimits(prod)">
                <div class="text-caption" v-if="
                  prod.ExitenciaTotal &&
                  prod.ExitenciaTotal < getCalculatedGlobalLimits(prod).Min
                ">
                  <p class="red--text mb-0">Baja existencia</p>
                </div>
                <div class="text-caption" v-if="
                  prod.ExitenciaTotal &&
                  prod.ExitenciaTotal < getCalculatedGlobalLimits(prod).Max
                ">
                  {{
                    $pgsHelper.formatNumber(
                      getCalculatedGlobalLimits(prod).Max - prod.ExitenciaTotal
                    )
                  }}
                  para ideal
                </div>
              </div>
            </td>
          </tr>
        </template>
      </tbody>
    </v-simple-table>
  </div>
</template>

<style></style>

<script>
import moment from "moment";
import ReporteExistenciasExporter from "../../../clases/ExcelMaker/ReporteExistenciasExcel";
import pdfmake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import ExistenciasGenerales from "../../../clases/PdfMakers/ExistenciasGenerales";
import { mapActions } from "vuex";
pdfmake.vfs = pdfFonts.pdfMake.vfs;
export default {
  name: "ReporteExistencias",
  components: {},
  props: [],
  data() {
    return {
      selectDep: "ALL",
      filter: "",
      MainDepartamento: "",
      costos: {},
      self: this,
      showModal: false,
      formKey: 0,
      formIndex: 0,
      editMode: false,
      processData: [],
      familias: [],
      Categories: [],
      editData: [],
      products: [],
      hoteles: [],
      usuarios: [],
      editedHotel: {},
      showModalPrecio: false,
      showModalModificador: false,
      showModalPrecioPorcentaje: false,
      showModalRecetas: false,
      showModalPresentaciones: false,
      zonas: [],
      config: {
        selectableRow: true,
        orderByCol: { Field: "", Type: "Asc" },
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addProducto",
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editProducto",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteProducto",
            require: true,
          },
          {
            text: "Presentaciones",
            icon: "lni lni-package",
            buttonId: "addPresentacion",
            require: true,
          },
          /* {
            text: "Modificar Precio",
            icon: "lni lni-dollar",
            buttonId: "editPrecio",
            require: true,
          },
          {
            text: "+/- % Precio",
            icon: "",
            buttonId: "editPrecioMasivo",
            require: false,
          },
          {
            text: "Admin. Modificadores",
            icon: "lni lni-list",
            buttonId: "adminModificadores",
            require: true,
          },*/
          /* {
            text: "Admin. Receta",
            icon: "lni lni-list",
            buttonId: "adminIngredientes",
            require: true,
          },*/
        ],
        fields: [
          {
            text: "Nombre",
            value: "Nombre",
          },
          {
            text: "Unidad",
            value: "Extra",
            format: (row) => {
              let html = row.Extra.AYB.UM;

              return html;
            },
          },
          {
            text: "Codigo",
            value: "Codigo",
          },
          {
            text: "Tipo",
            value: "Tipo",
          },
          {
            text: "Categoria",
            value: "categoria_name",
            canBeFiltered: true,
          },
          {
            text: "Familia",
            value: "Familia",
            canBeFiltered: true,
          },
          {
            text: "Departamentos",
            value: "Departamentos",
          },
          {
            text: "Existencia",
            value: "existenciaData", //'Existencia',
            canBeFiltered: true,
            format: (row) => {
              let html = "";
              row["existenciaData"].forEach((element) => {
                html +=
                  "<span>&#8226;</span> " +
                  element.NombreOrigen +
                  ": " +
                  element.Price.Stock +
                  "<br/>";
              });
              return html;
            },
          },
          {
            text: "Costo",
            value: "Costeo",
            format: (row) => {
              let html = "";
              if (row["Costeo"]) {
                row["Costeo"].forEach((element) => {
                  html +=
                    "<span>&#8226;</span> " +
                    element.depto +
                    ": " +
                    this.$pgsHelper.formatNumber(element.uct.C) +
                    " " +
                    element.uct.M +
                    "<br/>";
                });
              }

              return html;
              //return '$'+row['Precio']+' '+row['Moneda']+'';
            },
          },
        ],
      },
    };
  },
  methods: {
    async exportarExcel() {
      const data = this.excelData;
      try {
        const buffer =
          await ReporteExistenciasExporter.exportReporteExistencias(data);
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "ReporteExistencias.xlsx";
        link.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error al generar el Excel:", error);
      }
    },
    async generatePdf() {
      let mainData = {
        TITLE: "Existencias generales",
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),
        dep: this.selectDep,
        productos: this.productosShow,
        Origenes: this.Origenes,
      };

      let docDefinition = ExistenciasGenerales.getDocDefinition(
        mainData,
        this.getCalculatedGlobalLimits
      );

      pdfmake.createPdf(docDefinition).open();
    },
    getCalculatedGlobalLimits(prod) {
      if (prod.amcs) {
        let AlertaOrigens = Object.entries(prod.amcs);
        let max = 0;
        let min = 0;
        AlertaOrigens.forEach((origen) => {
          max += Number(origen[1].eidl);
          min += Number(origen[1].emin);
        });
        return { Max: max, Min: min };
      }

      return false;
    },
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "addProducto") {
        this.formIndex++;
        this.editMode = false;
        this.editData = {};
        this.$pgsHelper.log(this.editData);
        this.showModal = true;
      }
      if (buttonId == "editProducto") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.getProductoById(idSelected[0]);
        this.$pgsHelper.log(this.editData);
        this.showModal = true;
      }
      if (buttonId == "editPrecio") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.getProductoById(idSelected[0]);
        this.showModalPrecio = true;
      }
      if (buttonId == "deleteProducto") {
        this.deleteProducto(idSelected[0]);
      }
      if (buttonId == "editPrecioMasivo") {
        this.formIndex++;
        this.editMode = false;
        this.editData = {};
        this.showModalPrecioPorcentaje = true;
      }
      if (buttonId == "addPresentacion") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.$pgsHelper.getById(
          this.global_prod,
          "id",
          idSelected[0]
        );
        this.showModalPresentaciones = true;
      }
      if (buttonId == "adminIngredientes") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.$pgsHelper.getById(
          this.global_prod,
          "id",
          idSelected[0]
        );
        this.showModalRecetas = true;
      }
    },
    optButtonClick(buttonId, ref) {
      if (buttonId == "editPrice") {
        this.editedHotel = this.getHotelinfoById(ref);
        this.toggleModal(true);
      }
    },
    successData(data, doAction) {
      data.Precio = parseFloat(data.Precio);
      data.Orden = Number(data.Orden);
      if (doAction == "CREATE") {
        this.addProduct(data);
      } else if (doAction == "EDIT") {
        this.editProduct(data);
      }
    },
    async deleteProducto(id) {
      const deletedObject = this.getProductoById(id) || { Id: id };
      let datos = { Id: id };
      this.$alert.alertConfirm({
        action: "eliminar",
        obj: "el producto",
        route: "PDV-Productos-deleteProducto",
        data: datos,
        onSuccess: () => {
          this.$pgsHelper.writeLog({
            Evento: "PRODUCTO_DELETE",
            Mensaje: "Producto eliminado ",
            reference: { id: id, tp: "AYB-Producto", al: "Producto" },
            data: deletedObject
          });
          this.getCategories();
        },
      });
    },
    editProduct(datos) {
      //datos.Departamento      =  this.MainDepartamento;
      this.$alert.alertConfirm({
        action: "editar",
        obj: "el producto",
        route: "PDV-Productos-updateProducto",
        data: datos,
        onSuccess: () => {
          this.toggleModal(false);
        },
      });
    },
    addProduct(datos) {
      this.$alert.alertConfirm({
        action: "crear",
        obj: "el producto",
        route: "PDV-Productos-createProducto",
        data: datos,
        onSuccess: () => {
          this.toggleModal(false);
        },
      });
    },
    saveModificadores(datos) {
      this.$alert.alertConfirm({
        action: "actualizar",
        obj: "los modificadores del producto",
        route: "PDV-Productos-updateProducto",
        data: datos,
        onSuccess: () => {
          this.showModalModificador = false;
        },
      });
    },
    toggleModal(open) {
      this.showModal = open;
    },
    async getZonasImpresion() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "/PDV/ZonasImpresion"
        );
      if (snapshot.exists()) {
        this.zonas = [];
        this.zonas.push({ Id: "TICKET-PRINTER", nomb: "Default" });
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            this.zonas.push(toAdd);
          }
        });
      }
    },
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    async getCategories() {
      this.Categories = await this.fetchCategories();
    },
    getCategoryById(code) {
      let itemIndex = this.$_.findIndex(this.Categories, { id: code });
      if (itemIndex >= 0) {
        return this.Categories[itemIndex];
      }

      return false;
    },
    getProductoById(code) {
      let itemIndex = this.$_.findIndex(this.global_prod, { id: code });
      if (itemIndex >= 0) {
        return this.global_prod[itemIndex];
      }

      return false;
    },
    async getProducts() { },
    async getFamilias() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Productos/Familias"
        );

      this.familias = [];
      this.familias = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    async getCostos() {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const data = await firestore.queryBuilder("PDV_Costos", [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ]);
      let globalCosto = {};
      let costos = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      costos.forEach((element) => {
        let prod = Object.entries(element.pds);
        prod.forEach((pd) => {
          if (!globalCosto[pd[0]]) {
            globalCosto[pd[0]] = [];
            globalCosto[pd[0]].push({ depto: element.dpt, ...pd[1] });
          } else {
            globalCosto[pd[0]].push({ depto: element.dpt, ...pd[1] });
          }
        });
      });
      this.costos = globalCosto;
    },
    searchInv() {
      this.processData = [];
      let prod = this.$store.getters.getProductos;
      let origenes = this.$store.getters.getOrigenes;
      let productos = [];
      prod.forEach((element) => {
        element.categoria_name = this.getCategoryById(element.Categoria).Nombre;
        element.familiaId = this.getCategoryById(element.Categoria).Familia;
        element.Familia = this.$pgsHelper.getById(
          this.familias,
          "id",
          element.familiaId
        ).Nombre;
        if (
          element.Tipo != "AYB-Producto" &&
          element.Tipo != "Producto-NInv" &&
          !element.Dlat
        ) {
          if (this.selectDep != "ALL") {
            if (
              element.Departamentos &&
              element.Departamentos.includes(this.selectDep)
            ) {
              productos.push(element);
            }
          } else {
            productos.push(element);
          }
        }
        //element.Orden = (element.Orden)?element.Orden:0;
      });

      productos.forEach((producto) => {
        let invData = [];
        let Existencia = {};
        let existenciaTotal = 0;
        let matchCount = 0;
        let Alerts = {};
        origenes.forEach((origen, index) => {
          let origenesNames = this.$store.getters.getCentrosConsumo;
          let itemIndex = this.$_.findIndex(origenesNames, {
            id: origen.Origen,
          });
          origen.nombreOrigen = origenesNames[itemIndex]?.Nombre;
          let OrProd = Object.entries(origen.Productos);
          let productMatch = null;
          if (origen.Productos[producto.id]) {
            productMatch = origen.Productos[producto.id];
            Alerts[origen.Origen] = { Min: 3, Max: 30 };
            matchCount++;
          }
          if (productMatch) {
            invData.push({
              Origen: origen.Origen,
              Price: productMatch,
              Costo: this.$pgsHelper.formatNumber(
                this.costos[producto.id]?.cto?.C || 0
              ),
              NombreOrigen: origen.nombreOrigen,
            });
            Existencia[origen.Origen] = {
              Origen: origen.Origen,
              Price: productMatch,
              Stock: productMatch.Stock,
              Costo: this.$pgsHelper.formatNumber(
                this.costos[producto.id]?.cto?.C || 0
              ),
              NombreOrigen: origen.nombreOrigen,
            };
            existenciaTotal += Number(productMatch.Stock);
          }
        });
        (producto.UnidadMedida = producto?.Extra?.AYB?.UM || "PZ"),
          (producto.Costeo = this.costos[producto.id]);
        producto.existenciaPrecio = invData;
        producto.existenciaData = invData;
        producto.ExistenciaAlmacen = Existencia;
        producto.Alertar = producto.Alerta >= existenciaTotal;
        producto.AlertaMax = 100;
        producto.ExitenciaTotal = existenciaTotal;
        producto.Alertas = Alerts;
      });

      let data = productos;
      /*let claims = this.$route.params.user.tokenResult.claims;
      if (claims?.Data?.Only?.AYB) {
        data = JSON.parse(JSON.stringify(productos)).filter((prod) => {
          if (prod.Departamentos && prod.Departamentos.includes('Restaurante')) {
            return true;
          } else {
            return false;
          }
        });
      }*/
      let sortReservations = this.$_.orderBy(data, "ExitenciaTotal", "asc");

      if (this.filter != "") {
        return sortReservations.filter((acc) =>
          acc.Nombre.toUpperCase().includes(this.filter.toUpperCase())
        );
      }
      this.processData = sortReservations;
    },
  },
  computed: {
    Origenes() {
      return this.$store.getters.getOrigenes;
    },
    productosShow() {
      let prods = this.processData;
      if (this.filter != "") {
        return prods.filter((acc) =>
          acc.Nombre.toUpperCase().includes(this.filter.toUpperCase())
        );
      }
      return prods;
    },
    departamentos() {
      let dep = [
        {
          id: "ALL",
          Nombre: "Todos",
        },
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
    excelData() {
      let ExcelData = [];
      this.processData.forEach((element) => {
        let DataProd = {
          Nombre: element.Nombre,
          UnidadMedida: element?.Extra?.AYB?.UM || "PZ",
          Codigo: element.Codigo,
          Familia: element.Familia,
          Categoria: element.categoria_name,
          Alerta: element.Alerta,
          AlertaMax: 100,
        };
        let total = 0;
        this.Origenes.forEach((cc) => {
          DataProd[cc.nombreOrigen] = element.ExistenciaAlmacen[cc.Origen]
            ? element.ExistenciaAlmacen[cc.Origen].Stock
            : 0;
          total =
            total +
            Number(
              element.ExistenciaAlmacen[cc.Origen]
                ? element.ExistenciaAlmacen[cc.Origen].Stock
                : 0
            );
        });
        DataProd.Total = total;
        ExcelData.push(this.$pgsHelper.cloneObj(DataProd));
      });
      return ExcelData;
    },
  },
  watch: {},
  mounted() { },
  created() {
    this.MainDepartamento = localStorage.getItem("selectedDepartment");
    this.getFamilias();
    this.getCategories();
    this.getZonasImpresion();
    this.getCostos();
    //this.getProducts();
  },
};
</script>
